import { FC, useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import classNames from "classnames";
import { Button } from "src/Components";
import Input from "../Input/Input";
import { getGlobalOffset } from "src/Utils";
import { useOutsideClick } from "src/Hooks";
import { PositionType } from "src/Components/Calendar/Calendar";
import { ReactComponent as CloseIcon } from "./assets/close small.svg";
import { ReactComponent as TickIcon } from "./assets/tick small.svg";
import { IModalEditProps } from ".";
import st from "./ModalEdit.module.scss";

export const ModalEdit: FC<IModalEditProps> = ( props ) => {

	const { type = "text", initValue = "", closeOutside = false, onChangeValue, renderInput, hint, className, children, ...otherProps } = props;
	const wrapperRef = useRef<HTMLDivElement>(null);
	const modalRef = useOutsideClick<HTMLDivElement>( () => closeOutside && setEditMode(false) );
	
	const [ editMode, setEditMode ] = useState<boolean>(false);
	const [ value, setValue ] = useState<string>(initValue);
	const [ position, setPosition ] = useState<PositionType>(null);

	useLayoutEffect( () => {
		const calcOffsetModalPosition = ( e?: any ) => {
			const wr = wrapperRef.current;
			if ( !!wr ) {
				const offset = getGlobalOffset( wr );
				let top = ( offset.top - ( !!e?.target ? e.target.scrollTop : offset.scrollTop ) );
				let left = ( offset.left - offset.scroll ) + offset.width + 8;
				setPosition( { top, left } );
			}
		};
		const scrollContainer = window.document.querySelector( ".scrolled" );
		if ( !!scrollContainer ) {
			scrollContainer.addEventListener( "scroll", calcOffsetModalPosition);
		}

		calcOffsetModalPosition();

		return () => {
			if ( !!scrollContainer ) {
				scrollContainer.removeEventListener( "scroll", calcOffsetModalPosition)
			}
		};
	// eslint-disable-next-line
	}, [ editMode ] );

	const renderModal = () => {
		if ( !!renderInput ) 
			return (
				<div ref={modalRef} className={st.modalEditCustom} style={{ ...position }}>
					{ renderInput( {...props, closeModal: () => setEditMode(false) } ) }
				</div>
			);
		return (
			<div ref={modalRef} className={st.modalEdit} style={{ ...position }}>
				<div className="emptyIcon" />
				<Input type={type} value={value} onChangeValue={ v => setValue(v) } />
				<div className={st.toolbar}>
					<Button size="min" outline onClick={() => !!onChangeValue && onChangeValue(value) } disable={ initValue === value}>
						<TickIcon />
					</Button>
					<Button size="min" outline onClick={() => setEditMode(false)}>
						<CloseIcon />
					</Button>
				</div>
			</div>
		);
	};

	return (
		<div ref={wrapperRef} className={classNames(st.modalEditWrapper, className, { [st.active]: editMode })} {...otherProps}>
			<Button size="min" outline onClick={ () => setEditMode( true )} active={editMode} hint={hint}>
				{ children } 
			</Button>
			{ editMode && createPortal( renderModal(), window.document.body ) }
		</div>
	);
};
